import { render, staticRenderFns } from "./stationDetail.vue?vue&type=template&id=dfb762b0&scoped=true&"
import script from "./stationDetail.vue?vue&type=script&lang=js&"
export * from "./stationDetail.vue?vue&type=script&lang=js&"
import style0 from "./stationDetail.vue?vue&type=style&index=0&id=dfb762b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb762b0",
  null
  
)

export default component.exports